import svg4everybody from 'svg4everybody';
import $ from 'jquery';
const menubtn = require('../blocks/menubtn/menubtn.js');
const tagcloud = require('../blocks/skills/tagcloud.js');
// const menu = require('../blocks/menu/menu.js');

$(() => {
	svg4everybody();
	menubtn();
	tagcloud();
	// menu();
});



// WEBPACK FOOTER //
// ./app/scripts/app.js